import { isAndroidWebView, isLinux } from '@eventbrite/feature-detection';
import { TicketsFormat } from '../../constants/statsig';
import { CheckoutState } from '../../state';
import { hasSomeTicketWithMoreThanOneVariant } from '../../utils/tickets';
import { getIsReservedSeating } from '../event';
import { getNamespaceValue } from '../utils/selector';

export const getSupportedTicketFormat = (
    state: CheckoutState,
): TicketsFormat => {
    // TODO: EB-208846 - Excluding events with Ticket Resellers
    return getNamespaceValue(state.event, 'ticketReseller') ||
        // TODO: EB-208847 - Excluding events with Waitlist
        getNamespaceValue(state.event, 'waitlistSettings') ||
        // TODO: EB-208851 & EB-208856 - Excluding events with segemented tickets
        hasSomeTicketWithMoreThanOneVariant(
            Object.values(state.tickets.ticketsById),
        ) ||
        // TODO: EB-208857 - Excluding Reserved Seating
        getIsReservedSeating(state) ||
        // TODO: EB-208841 - Exclude Linux until it is supported
        (isLinux() && !isAndroidWebView())
        ? TicketsFormat.listItem
        : TicketsFormat.card;
};

export const getHasBogoTickets = (state: CheckoutState): boolean => {
    return getNamespaceValue(state.event, 'hasBogoTickets');
};
